import { useCallback, useEffect, useState } from "react";
import CardContent from "@mui/material/CardContent";
import PaginationCM from "components/shared/Pagination";
import LoadingPartCM from "components/shared/PartLoading";
import { Link } from "react-router-dom";
import {
  StyledButtonsDiv,
  StyledMainWrapper,
  StyledTypography,
  StyledContainer,
  StyledMainDiv,
  StyledAccordion,
  StyledTypographyText,
  StyledTypographyDiv,
} from "./CommentButton.style";
import { Button } from "@mui/material";
import { BsQuestionCircle } from "react-icons/bs";
import { MdQuestionAnswer } from "react-icons/md";
import Modal from "components/shared/Modal";
import { Grid, TextField } from "@mui/material";
import {
  addQuestionRequest,
  getQuestionAnswerRequest,
  addAnswerRequest,
} from "api/requests";
import { PAGINATION_LIMIT_10 } from "constants";
import Toast from "helper/toast";
import { yupResolver } from "@hookform/resolvers/yup";
import { addQuestionSchema } from "validations";
import useHttp from "hooks/use-http";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import useAuth from "hooks/use-auth";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AnswerButton from "components/Q&a/AnswerButton";

export default function ShareButton() {
  const AuthCTX = useAuth();
  const params = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const { request, loading } = useHttp();
  const [messages, setMessages] = useState({ data: [], count: 0 });
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [page, setPage] = useState(1);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(addQuestionSchema),
  });
  const [QId, setQuestionId] = useState("");
  const [questionText, setQuestionText] = useState("");
  const [showAnswerModal, setShowAnswerModal] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleshowAnswerModal = (rowId, rowText) => {
    setShowAnswerModal((state) => !state);
    setQuestionId(rowId);
    setQuestionText(rowText);
  };

  const handleCloseAnswerModal = () => {
    setShowAnswerModal(false);
  };

  const onSubmitAnswer = async (data) => {
    const res = await request({
      url: () =>
        addAnswerRequest({
          ...data,
          product_id: params.productId,
          question_id: QId,
        }),
    });
    setShowAnswerModal(false);
    if (res) {
      reset({
        answer: "",
      });
      Toast({ type: "success", title: "ثبت پاسخ" });
    }
  };

  const onSubmit = async (data) => {
    const res = await request({
      url: () => addQuestionRequest({ ...data, product_id: params.productId }),
    });
    setIsOpen(false);
    if (res) {
      reset({
        description: "",
        title: "",
      });
      Toast({ type: "success", title: "ثبت پرسش" });
    }
  };

  const getMessages = useCallback(async () => {
    const res = await request({
      url: getQuestionAnswerRequest,
      values: {
        skip: (page - 1) * PAGINATION_LIMIT_10,
        limit: PAGINATION_LIMIT_10,
        product_id: params.productId,
      },
    });

    let transformedData = res.data.map((items) => ({
      id: items.id,
      user: items?.author?.full_name,
      text: items?.text,
      date: items?.created_at?.string,
      answers: items?.answers,
    }));

    setMessages({ data: transformedData, count: res.count });
  }, [page, request]);

  useEffect(() => {
    getMessages();
  }, []);

  return (
    <>
      <StyledMainWrapper>
        {/* {!AuthCTX.isLoggedIn ? (
          ""
        ) : ( */}
        <Button onClick={() => setIsOpen(true)}>
          <BsQuestionCircle style={{ paddingLeft: "6px", fontSize: "27px" }} />
          ثبت پرسش
        </Button>
        {/* )} */}
        <CardContent style={{ padding: "5px" }}>
          {loading ? (
            <div style={{ textAlign: "center", padding: "28px" }}>
              <LoadingPartCM />
            </div>
          ) : messages.count < 1 ? (
            <div style={{ textAlign: "center", padding: "28px" }}>
              پرسشی یافت نشد
            </div>
          ) : (
            <StyledContainer pb={2} style={{ marginTop: "22px" }}>
              {messages.data.map((items, index) => {
                return (
                  <StyledMainDiv key={"row" + items.id}>
                    <StyledAccordion
                      expanded={expanded === `"panel" + ${items.id}`}
                      onChange={handleChange(`"panel" + ${items.id}`)}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                      >
                        <StyledTypographyDiv>
                          <StyledTypography sx={{ flexShrink: 0 }}>
                            <BsQuestionCircle
                              style={{
                                paddingLeft: "10px",
                                fontSize: "31px",
                                color: "#009AC2",
                              }}
                            />{" "}
                            {items.text}
                          </StyledTypography>
                        </StyledTypographyDiv>
                      </AccordionSummary>
                      <AccordionDetails style={{ padding: "0" }}>
                        {items?.answers.map((item, index) => (
                          <StyledTypographyText key={index}>
                            <span
                              style={{
                                paddingLeft: "10px",
                                color: "#009AC2",
                                marginRight: "-10px",
                              }}
                            >
                              پاسخ :{" "}
                            </span>{" "}
                            <span>{item.text}</span>
                          </StyledTypographyText>
                        ))}
                      </AccordionDetails>
                      {!AuthCTX.isLoggedIn ? (
                        ""
                      ) : (
                        <div
                          style={{ direction: "ltr", paddingBottom: "10px" }}
                        >
                          <Button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleshowAnswerModal(items.id, items.text);
                            }}
                          >
                            ثبت پاسخ
                            <MdQuestionAnswer
                              style={{ paddingLeft: "6px", fontSize: "27px" }}
                            />
                          </Button>
                        </div>
                      )}
                    </StyledAccordion>
                  </StyledMainDiv>
                );
              })}
              <Grid container my={2} spacing={1}>
                <Grid item xs={12}>
                  <PaginationCM
                    handleChange={(e, val) => setPage(val)}
                    page={page}
                    limit={PAGINATION_LIMIT_10}
                    count={messages.count}
                  />
                </Grid>
              </Grid>
            </StyledContainer>
          )}
        </CardContent>
      </StyledMainWrapper>

      <Modal show={isOpen} onClose={() => setIsOpen(false)} title="پرسش شما">
        <StyledButtonsDiv>
          {!AuthCTX.isLoggedIn ? (
            <>
              <p className="text">
                لطفا برای ثبت پرسش و پاسخ وارد حساب کاربری خود شوید.
              </p>
              <div style={{ textAlign: "center", marginTop: "50px" }}>
                <Link to={`/login`}>
                  <Button variant="outlined">
                    <span style={{ marginRight: "10px", marginLeft: "10px" }}>
                      ورود به حساب کاربری
                    </span>
                  </Button>
                </Link>
              </div>
            </>
          ) : (
            <>
              <p className="text">
                پرسش های خود را با دیگران به اشتراک بگذارید.
              </p>
              <Grid container spacing={1}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <TextField
                    id="description"
                    label="پرسش"
                    fullWidth
                    multiline
                    rows={4}
                    {...register("description")}
                    error={Boolean(errors["description"])}
                    helperText={errors["description"]?.message}
                    style={{ width: "100%", overflow: "visible" }}
                    onChange={(e) => setQuestion(e.target.value)}
                  />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Button
                    variant="contained"
                    onClick={handleSubmit(onSubmit)}
                    fullWidth
                    style={{ height: "45px", marginTop: "12px" }}
                    disabled={question.length <= 3 || loading ? true : false}
                  >
                    {loading ? <LoadingPartCM /> : "ثبت پرسش"}
                  </Button>
                </Grid>
              </Grid>
            </>
          )}
        </StyledButtonsDiv>
      </Modal>
      <AnswerButton
        show={showAnswerModal}
        onClose={handleCloseAnswerModal}
        rowId={QId}
        rowText={questionText}
      >
        <StyledButtonsDiv>
          <p className="text">{questionText}</p>

          <Grid container spacing={1}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <TextField
                id="answer"
                label="پاسخ"
                fullWidth
                multiline
                rows={4}
                {...register("answer")}
                error={Boolean(errors["answer"])}
                helperText={errors["answer"]?.message}
                style={{ width: "100%", overflow: "visible" }}
                onChange={(e) => setAnswer(e.target.value)}
              />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Button
                variant="contained"
                onClick={handleSubmit(onSubmitAnswer)}
                fullWidth
                style={{ height: "45px", marginTop: "12px" }}
                disabled={answer.length <= 3 || loading ? true : false}
              >
                {loading ? <LoadingPartCM /> : " ثبت پاسخ "}
              </Button>
            </Grid>
          </Grid>
        </StyledButtonsDiv>
      </AnswerButton>
    </>
  );
}
